import { render } from "./ListaSinistrosAcordoView.vue?vue&type=template&id=642eb05a&scoped=true"
import script from "./ListaSinistrosAcordoView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosAcordoView.vue?vue&type=script&lang=js"

import "./ListaSinistrosAcordoView.vue?vue&type=style&index=0&id=642eb05a&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642eb05a"]])

export default __exports__